import { useTranslation } from "react-i18next";
import { FormAutocomplete, RowInfo } from "../../common";
import { VideoLengthModal, VideoSharingModal } from "../modals";

const Video = ({ useQuery }) => {
  const { t } = useTranslation();

  return (
    <>
      <p dangerouslySetInnerHTML={{__html: t(`Require the player to submit a video.`)}} />
      <RowInfo help={<VideoLengthModal />}>
        <FormAutocomplete
            label={t("Video length")}
            name="video_length"
            useQuery={useQuery}
            options={[
                { id: 1, name: "1s" },
                { id: 2, name: "2s" },
                { id: 3, name: "3s" },
                { id: 5, name: "5s" },
                { id: 7, name: "7s" },
                { id: 10, name: "10s" },
                { id: 20, name: "20s" },
                { id: 30, name: "30s" },
                { id: 45, name: "45s" },
                { id: 60, name: "60s" },
            ]}
            size="small"
            creatable
        />
      </RowInfo>
      <RowInfo help={<VideoSharingModal />}>
        <FormAutocomplete
            label={t("Shared as")}
            name="task_subtype"
            useQuery={useQuery}
            options={[
                { id: "0", name: t('standard video') },
                { id: "1", name: t('animated gif') },
                { id: "2", name: t('audio only') },
            ]}
            size="small"
        />
      </RowInfo>
    </>
  )
};

export default Video;
